<div class="date-time-picker" [ngClass]="{ 'date-time-picker--collapsed': isCollapsed, 'date-time-picker--vertical': orientation === 'vertical' }">
  @if (isCollapsed && selectedDateTime) {
    <div class="date-time-picker__summary">
      <div class="date-time-picker__summary-info">
        <i class="fa-solid fa-calendar-days" aria-hidden="true"></i>
        <div class="date-time-picker__summary-text">
          <span class="date-time-picker__summary-date">{{ selectedDateLabel }}</span>
          <span class="date-time-picker__summary-time">{{ selectedTimeLabel }}</span>
        </div>
      </div>
      <button type="button" class="date-time-picker__edit" (click)="onEditSelection()">
        {{ 'services.item.edit' | transloco }}
      </button>
    </div>
  }

  <div class="date-time-picker__body" [ngClass]="{ 'date-time-picker__body--collapsed': isCollapsed }">
    <div class="date-time-picker__panel date-time-picker__panel--calendar" #calendarPanel>
      <div class="date-time-picker__header">
        <div class="date-time-picker__month">
          <span class="date-time-picker__month-name">{{ monthName }}</span>
          <span class="date-time-picker__month-year">{{ yearLabel }}</span>
        </div>
        <div class="date-time-picker__nav">
          <button type="button" (click)="prevMonth()" [disabled]="isPrevDisabled" aria-label="Previous month">
            <i class="fa-solid fa-chevron-left"></i>
          </button>
          <button type="button" (click)="nextMonth()" aria-label="Next month">
            <i class="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <div class="date-time-picker__weekdays">
        @for (day of weekdayLabels; track day) {
          <div class="date-time-picker__weekday">{{ day }}</div>
        }
      </div>

      <div class="date-time-picker__grid">
        @if (isLoadingDays) {
          @for (skeleton of loadingSkeletonItems; track skeleton) {
            <div class="date-time-picker__day-skeleton" aria-hidden="true"></div>
          }
        }
        @if (!isLoadingDays) {
          @for (day of calendarDays; track day.key) {
            <button
              type="button"
              class="date-time-picker__day"
              [ngClass]="{
                'date-time-picker__day--muted': !day.inCurrentMonth,
                'date-time-picker__day--selected': day.selected,
                'date-time-picker__day--disabled': day.disabled || !day.available,
                'date-time-picker__day--today': day.today
              }"
              (click)="onSelectDay(day)"
              [disabled]="day.disabled || !day.available"
            >
              {{ day.label }}
            </button>
          }
        }
      </div>
    </div>

    <div
      class="date-time-picker__panel date-time-picker__panel--slots"
      #slotsPanel
      [style.height.px]="shouldLockPanelHeight ? (panelHeight || null) : null"
      [style.maxHeight.px]="shouldLockPanelHeight ? (panelHeight || null) : null"
    >
      <div class="date-time-picker__slots">
        @if (!selectedDate) {
          <p class="date-time-picker__placeholder">
            {{ 'marketplace.booking.create.date-time-picker.select-date' | transloco }}
          </p>
        }

        @if (selectedDate) {
          @if (isLoadingSlots) {
            <p class="date-time-picker__placeholder">
              {{ 'marketplace.booking.create.date-time-picker.loading-slots' | transloco }}
            </p>
          }

          @if (!isLoadingSlots && noSlotsForDay) {
            <p class="date-time-picker__placeholder">
              {{ 'marketplace.booking.create.date-time-picker.no-slots' | transloco }}
            </p>
          }

          @if (!isLoadingSlots && !noSlotsForDay) {
            <div class="date-time-picker__slot-list">
              @for (slot of timeSlotOptions; track slot.key) {
                <button
                  type="button"
                  class="date-time-picker__slot"
                  [ngClass]="{ 'date-time-picker__slot--selected': slot.key === selectedSlotKey }"
                  (click)="onSelectSlot(slot)"
                >
                  <span class="date-time-picker__slot-dot"></span>
                  <span class="date-time-picker__slot-label">{{ slot.label }}</span>
                </button>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
